var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseEntity } from '../../../pages/modules/base-entity';
import { autoinject, BindingEngine, transient } from 'aurelia-framework';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
import { Router } from 'aurelia-router';
import { NotificationClientService, NotificationType } from '../../../../services/basics/notification-client.service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { EntityTypes } from '../../../../models/basics/basics.models';
import { RouterConstants } from '../../../../configuration/router.constants';
import { StepEnum } from '../../../../models/modules/lotteryplatofrm.models';
import { I18N } from 'aurelia-i18n';
import { TokenClient } from '../../../../services/authentication/token-client.service';
import { ValidationRules, ValidationControllerFactory, validateTrigger } from "aurelia-validation";
import * as Enumerable from 'linq';
import { Guid } from '../../../../utilities/guid';
import { UserClaimsService } from '../../../../services/authentication/user-claims.service';
import { BaseClaims } from '../../../../constants/authentication/base-claims';
import { BundleClientService } from '../../../../services/modules/bundle-client.service';
import { BundleBasicMeta } from './steps/bundle-basic-meta';
import { BundleChangeLog } from './steps/bundle-changelog';
import { BundleTicketLines } from './steps/bundle-ticket-lines';
import { BundleTickets } from './steps/bundle-tickets';
import { BundleTicketDiscounts } from './steps/bundle-ticket-discounts';
import { BundleBrandingDialog } from './dialogs/bundle-branding-dialog';
import { BundleBrandingAssets } from './dialogs/branding-steps/bundle-branding-assets';
import { BundleBrandingColors } from './dialogs/branding-steps/bundle-branding-colors';
import { BundleBrandingText } from './dialogs/branding-steps/bundle-branding-text';
import { BundleBrandingImages } from './dialogs/branding-steps/bundle-branding-images';
import { BundleBrandingAds } from './dialogs/branding-steps/bundle-branding-ads';
import { DialogServiceConstants } from '../../../../constants/basics/dialog.constants';
var Bundle = /** @class */ (function (_super) {
    __extends(Bundle, _super);
    function Bundle(validationControllerFactory, dialogClientService, tokenClient, router, bindingEngine, notificationService, eventAggregator, bundleClientService, i18N, userClaimsService, bundleBasicMeta, bundleChangeLog, bundleTicketLines, bundleTickets, bundleTicketDiscounts, bundleBrandingDialog, bundleBrandingAssets, bundleBrandingColors, bundleBrandingText, bundleBrandingImages, bundleBrandingAds) {
        var _this = _super.call(this, router, bindingEngine, i18N, notificationService, eventAggregator) || this;
        _this.dialogClientService = dialogClientService;
        _this.tokenClient = tokenClient;
        _this.router = router;
        _this.bindingEngine = bindingEngine;
        _this.notificationService = notificationService;
        _this.eventAggregator = eventAggregator;
        _this.bundleClientService = bundleClientService;
        _this.userClaimsService = userClaimsService;
        _this.bundleBasicMeta = bundleBasicMeta;
        _this.bundleChangeLog = bundleChangeLog;
        _this.bundleTicketLines = bundleTicketLines;
        _this.bundleTickets = bundleTickets;
        _this.bundleTicketDiscounts = bundleTicketDiscounts;
        _this.bundleBrandingDialog = bundleBrandingDialog;
        _this.bundleBrandingAssets = bundleBrandingAssets;
        _this.bundleBrandingColors = bundleBrandingColors;
        _this.bundleBrandingText = bundleBrandingText;
        _this.bundleBrandingImages = bundleBrandingImages;
        _this.bundleBrandingAds = bundleBrandingAds;
        _this.activityLogEntitiesSave = [EntityTypes.Bundle];
        _this.controller = null;
        _this.controller = validationControllerFactory.createForCurrentScope();
        _this.controller.validateTrigger = validateTrigger.changeOrBlur;
        return _this;
    }
    Object.defineProperty(Bundle.prototype, "defaultBundle", {
        get: function () {
            return {
                name: null,
                numberOfLines: 1,
                createdDate: new Date(),
                isActive: true,
                entityType: EntityTypes.Bundle,
                identifier: Guid.generateGuid(),
                pricingModels: [],
                bundleBrandLotteries: [],
                brandId: null,
                sequenceNumber: 0,
                gameIdentifier: ""
            };
        },
        enumerable: false,
        configurable: true
    });
    Bundle.prototype.activate = function (params, navigationInstruction) {
        return _super.prototype.activate.call(this, params, navigationInstruction);
    };
    Bundle.prototype.attached = function () {
        $(".oa-drag").remove();
        return _super.prototype.attached.call(this);
    };
    Bundle.prototype.initializeItemOverride = function (newItem) {
        if (newItem) {
            var options = this.getOptions();
            newItem.brandId = options.brandId;
            newItem.createdDate = new Date();
            newItem.gameIdentifier = Guid.generateGuid();
            newItem.pricingModels.push({
                brandId: options.brandId,
                operatorId: options.operatorId,
                isActive: true,
                lotteryId: null,
                lotteryBrandPrices: [],
                lotteryBrandDiscounts: []
            });
            this.setNavigationInfo(newItem);
            this.initValidations(newItem);
        }
    };
    Bundle.prototype.getOptions = function () {
        var key = "bundle_navigation_info";
        var options;
        if (this._navigationInstruction && this._navigationInstruction.settings && this._navigationInstruction.settings.options)
            options = JSON.stringify(this._navigationInstruction.settings.options);
        if (!options)
            options = localStorage.getItem(key);
        if (options) {
            var optionsObj = JSON.parse(options);
            localStorage.setItem(key, options);
            return optionsObj;
        }
        return null;
    };
    Bundle.prototype.setNavigationInfo = function (newItem) {
        var options = this.getOptions();
        newItem.navigationInfo = {
            brandId: options.brandId,
            brandName: options.brandName,
            brandLanguages: options.brandLanguages,
            brandLotteries: options.brandLotteries,
            brandDefaultCurrencyId: options.brandDefaultCurrencyId,
            brandTemplateInternalName: options.brandTemplateInternalName ? options.brandTemplateInternalName : "",
            brandThemeInternalName: options.brandThemeInternalName ? options.brandThemeInternalName : ""
        };
    };
    Bundle.prototype.initializeItemOverrideForUpdate = function (newItem) {
        var options = this.getOptions();
        newItem.brandId = options.brandId;
        if (newItem.pricingModels.length == 0)
            newItem.pricingModels.push({
                brandId: options.brandId,
                operatorId: options.operatorId,
                isActive: true,
                lotteryId: null,
                lotteryBrandPrices: [],
                lotteryBrandDiscounts: []
            });
        this.setNavigationInfo(newItem);
        this.initValidations(newItem);
    };
    Bundle.prototype.initValidations = function (newItem) {
        this.rules = ValidationRules
            .ensure(function (x) { return x.name; }).required().withMessage("Name is required.")
            .ensure(function (x) { return x.pricingModels; })
            .satisfies(function (x) {
            var lotteryBrandPrices = Enumerable.from(x).where(function (x) { return x.brand != null; });
            var isValid = true;
            if (lotteryBrandPrices.toArray().length == 1) {
                lotteryBrandPrices.selectMany(function (y) { return y.lotteryBrandPrices; }).forEach(function (v) { if (v.price == null || v.price == 0)
                    isValid = false; });
            }
            return isValid;
        }).withMessage("Enter a valid ticket price for every range. Prices cannot be left empty or zero.")
            .ensure(function (x) { return x.pricingModels; })
            .satisfies(function (x) {
            var lotteryBrandPrices = Enumerable.from(x).where(function (x) { return x.brand != null; });
            var isValid = true;
            if (lotteryBrandPrices.toArray().length == 1) {
                lotteryBrandPrices.selectMany(function (y) { return y.lotteryBrandPrices; }).forEach(function (v) { if (v.currencyId == null || v.currencyId == 0)
                    isValid = false; });
            }
            return isValid;
        }).withMessage("Currency field cannot be empty.")
            .ensure(function (x) { return x.pricingModels; })
            .satisfies(function (x) {
            var lotteryBrandPrices = Enumerable.from(x).where(function (x) { return x.brand != null; });
            var isValid = true;
            if (lotteryBrandPrices.toArray().length == 1) {
                var brandPriceArray = lotteryBrandPrices.selectMany(function (y) { return y.lotteryBrandPrices; }).where(function (x) { return x.lotteryJackpotRangeId == null
                    && x.currencyId != 0; }).select(function (x) { return x.currencyId; }).toArray();
                if ((new Set(brandPriceArray)).size !== brandPriceArray.length) {
                    isValid = false;
                }
            }
            return isValid;
        }).withMessage("You cannot select same currency.Please check it.")
            .on(newItem)
            .rules;
        this.rulesBundleLotteries = ValidationRules
            .ensure(function (x) { return x.sharePercentage; }).satisfies(function (x) { return x > 0 && x <= 100; }).withMessage("Share Percentage must be between 1 and 100.")
            .rules;
    };
    Bundle.prototype.getPropertiesToSkip = function () {
        return ["navigationInfo"];
    };
    Bundle.prototype.getSteps = function () {
        var stepList = [];
        stepList.push({
            title: this.i18N.tr('bundle-basic-meta'),
            step: StepEnum.BundleBasicMeta,
            show: true,
            vm: this.bundleBasicMeta,
            view: '../../app/admin/bundle/steps/bundle-basic-meta.html'
        });
        stepList.push({
            title: this.i18N.tr('ticket-lines'),
            step: StepEnum.BundleTicketLines,
            show: true,
            vm: this.bundleTicketLines,
            view: '../../app/admin/bundle/steps/bundle-ticket-lines.html',
            loadOnceClicked: true
        });
        stepList.push({
            title: this.i18N.tr('change-log'),
            step: StepEnum.BundleChangeLog,
            vm: this.bundleChangeLog,
            show: this.userClaimsService.hasPermission(BaseClaims.ViewAuditHistory),
            view: '../../app/admin/bundle/steps/bundle-changelog.html',
            loadOnceClicked: true
        });
        stepList.push({
            title: this.i18N.tr('bundle-tickets-prices'),
            step: StepEnum.BundleTickets,
            vm: this.bundleTickets,
            show: true,
            view: '../../app/admin/bundle/steps/bundle-tickets.html'
        });
        stepList.push({
            title: this.i18N.tr('lottery-tickets-discounts'),
            step: StepEnum.BundleTicketDiscounts,
            vm: this.bundleTicketDiscounts,
            show: true,
            view: '../../app/admin/bundle/steps/bundle-ticket-discounts.html'
        });
        return stepList;
    };
    // Inherited
    Bundle.prototype.getItem = function (id) {
        var options = this.getOptions();
        if (options) {
            var request = {
                id: id,
                brandId: options.brandId
            };
            return this.bundleClientService.getBundleForAdmin(request);
        }
        this.router.navigate("/");
    };
    Bundle.prototype.getItemId = function () {
        return this.item.bundleId;
    };
    Bundle.prototype.getEntityType = function () {
        return EntityTypes.Bundle;
    };
    Bundle.prototype.saveItem = function (id, changes) {
        var request = {
            id: id, changes: changes,
            brandId: this.item.navigationInfo ? this.item.navigationInfo.brandId : null
        };
        return this.bundleClientService.save(request);
    };
    Bundle.prototype.getUpdateRoute = function () {
        return RouterConstants.RouteNames.ManageBundle;
    };
    Bundle.prototype.initializeItemForCreate = function () {
        return this.defaultBundle;
    };
    Bundle.prototype.getListRoute = function () {
        return RouterConstants.RouteNames.ListBrands;
    };
    Bundle.prototype.deleteBundle = function () {
        var _this = this;
        require("../dialogs/delete-modal"); // this is to show delete modal dialog
        if (this.item.bundleId) {
            this.dialogClientService.show(DialogServiceConstants.URLs.DeleteModalConfirmation, {
                delete: function () { return new Promise(function (resolve, reject) {
                    _this.bundleClientService.delete({
                        bundleId: _this.item.bundleId,
                        brandId: _this.item.navigationInfo ? _this.item.navigationInfo.brandId : null
                    }).then(function (response) {
                        if (response.deleteSuccessfully) {
                            _this.notificationService.show(_this.i18N.tr("bundle-delete-notification-title"), _this.i18N.tr("bundle-delete-notification-message-success"), NotificationType.Success);
                            _this.router.navigateToRoute(RouterConstants.RouteNames.ManageBrand, { id: _this.item.navigationInfo.brandId });
                        }
                        else {
                            _this.notificationService.show(_this.i18N.tr("bundle-delete-notification-title"), _this.i18N.tr("bundle-delete-notification-message-error"), NotificationType.Error);
                        }
                    }).catch(function () {
                        _this.notificationService.show(_this.i18N.tr("bundle-delete-notification-title"), _this.i18N.tr("bundle-delete-notification-message-error"), NotificationType.Error);
                    });
                }); }
            });
        }
    };
    Bundle.prototype.beforeSave = function (skipValidation, resolve) {
        // calculate the number of draws based on lotteries set.
        // if(this.item && this.item.pricingModel && this.item.pricingModel.lotteryBrandDiscounts){
        //     let lotteryBrandDiscounts = Enumerable.from(this.item.pricingModel.lotteryBrandDiscounts).where(x=>x.isMonthlySubscription).toArray();
        //     if(lotteryBrandDiscounts){
        //         let numberOfDrawsForAllLotteries = Enumerable.from(this.item.bundleBrandLotteries).sum(x=>Number(x.numberOfDraws));
        //         lotteryBrandDiscounts.forEach(element => {
        //             element.numberOfDraws = numberOfDrawsForAllLotteries;
        //         });
        //     }
        // }
        var _this = this;
        Promise.all([
            this.controller.validate({ object: this.item, rules: this.rules }),
        ].concat(this.item.bundleBrandLotteries.map(function (x) { return _this.controller.validate({ object: x, rules: _this.rulesBundleLotteries }); }))).then(function (result) {
            resolve(Enumerable.from(result).all(function (x) { return x.valid; }), _this.controller.errors.map(function (x) { return x.message; }).join("\n"));
        });
    };
    Bundle = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ValidationControllerFactory, DialogClientService, TokenClient,
            Router, BindingEngine, NotificationClientService,
            EventAggregator, BundleClientService, I18N,
            UserClaimsService, BundleBasicMeta, BundleChangeLog, BundleTicketLines,
            BundleTickets, BundleTicketDiscounts, BundleBrandingDialog,
            BundleBrandingAssets,
            BundleBrandingColors,
            BundleBrandingText,
            BundleBrandingImages,
            BundleBrandingAds])
    ], Bundle);
    return Bundle;
}(BaseEntity));
export { Bundle };
